module.exports = __webpack_public_path__ + "static/Roboto-BoldItalic-9e81ca6c867d6580bb93f6fae3e43986.woff2";